/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { createConditionalNode } from '../../factoriesAny.js';
export var ConditionalNodeDependencies = {
  NodeDependencies,
  createConditionalNode
};